// Полка пользователя: карточки книг, поиск, рецензии.
import { application } from "../application.js";

import MarkdownToolbarController from "../controllers/markdown_toolbar_controller.js";
import ReviewViewerController from "../controllers/review_viewer_controller.js";
import ShelfBookController from "../controllers/shelf_book_controller.js";
import ShelfBookSearchController from "../controllers/shelf_book_search_controller.js";
import ShelfProgressController from "../controllers/shelf_progress_controller.js";
import ShelfReviewController from "../controllers/shelf_review_controller.js";
import ShelfSheetController from "../controllers/shelf_sheet_controller.js";

application.register("markdown-toolbar", MarkdownToolbarController);
application.register("review-viewer", ReviewViewerController);
application.register("shelf-book", ShelfBookController);
application.register("shelf-book-search", ShelfBookSearchController);
application.register("shelf-progress", ShelfProgressController);
application.register("shelf-review", ShelfReviewController);
application.register("shelf-sheet", ShelfSheetController);

export { application };
